import { Content, ContentType } from './wolters-kluwer/content';

/**
 * Represents external content inside a (sub) section
 */
export interface ExternalContent extends Content {
    /**
     * Url where the external content can be retrieved from
     */
    downloadUrl: string;
    /**
     * Optional: description - e.g.: 'RTF Dokument'
     */
    description?: string;
}

export function isExternalContent(value: unknown): value is ExternalContent {
    return (
        typeof value === 'object' &&
        value !== null &&
        'type' in value &&
        value['type'] === ContentType.External
    );
}
